import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-bookmaker-detail',
  templateUrl: './bookmaker-detail.component.html',
  styleUrls: ['./bookmaker-detail.component.css']
})
export class BookmakerDetailComponent extends BaseClass<any> implements OnInit {

  @Input() data: any;
  @Output() betDt = new EventEmitter();
  @Output() updateData = new EventEmitter();
  @Output() changeExpo = new EventEmitter();
  @Output() closeBet = new EventEmitter();

  public marketData: any;
  public odds: any;
  public expo: any;
  public nextExpo: any;

  public betSlipData: any;

  constructor(public service: WebserviceService) { super(); }

  getServices(): IbaseService<any> {
    return this.service;
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (this.data) {
      this.marketData = this.data?.marketData;
      this.odds = this.data?.odds;
      this.expo = this.data?.expo;
      this.nextExpo = this.data?.nextExpo;
      this.betSlipData = this.data?.betSlipData;
    }
  }

  openBetPlace(item: any, oddsItem: any, i: any, bet: any, oi: any, bkOrLy: any, key: string) {
    this.betDt.emit({ item: item, oddsItem: oddsItem, i: i, bet: bet, oi: oi, bkOrLy: bkOrLy, key: key })
  }

}
